import { PremierServiceScheduleDTO } from "../DTO/premierServiceScheduleDTO";
import { BasicRequest } from "./basicRequest";

export class CreatePremierServiceScheduleRequest extends BasicRequest{
    
    public premierServiceSchedule!:PremierServiceScheduleDTO;

    constructor(){
        super();
    }
}